// import React, { useMemo, useState } from "react";
// import {
//   StarOutlined,
//   PlusSquareOutlined,
//   SearchOutlined,
//   CaretDownOutlined,
//   LeftOutlined,
// } from "@ant-design/icons";
// import { Button } from "antd";
// import { useNavigate } from "react-router-dom";

// type Row = {
//   id: string;
//   requested: string;
//   manu: string;
//   model: string;
//   options: string;
//   keepAlive: boolean;
//   status: "Active" | "Closed";
//   priority: number;
//   type: "WTB" | "CAL" | "WTS";
//   owner: string;
// };

// const INITIAL_DATA: Row[] = [
//   {
//     id: "1",
//     requested: "12/18/2026 10:12:27",
//     manu: "Agilent HP Keysight",
//     model: "N7776C",
//     options: '7116  "Have PO"',
//     keepAlive: true,
//     status: "Active",
//     priority: 6,
//     type: "WTB",
//     owner: "sean",
//   },
//   {
//     id: "2",
//     requested: "12/18/2026 10:21:01",
//     manu: "Agilent HP Keysight",
//     model: "81134A",
//     options: '"Have PO"',
//     keepAlive: true,
//     status: "Active",
//     priority: 6,
//     type: "WTB",
//     owner: "sean",
//   },
//   {
//     id: "3",
//     requested: "12/18/2026 10:09:08",
//     manu: "Agilent HP Keysight",
//     model: "N9310B",
//     options: "",
//     keepAlive: true,
//     status: "Active",
//     priority: 6,
//     type: "WTB",
//     owner: "rkanna",
//   },
// ];

// const Quotes: React.FC = () => {
//   const [activeType, setActiveType] = useState<"WTB" | "CAL" | "WTS">("WTB");
//   const [data, setData] = useState<Row[]>(INITIAL_DATA);

//   const [typeScope, setTypeScope] = useState<Record<"WTB" | "CAL" | "WTS", "Active" | "Today" | "All">>({
//     WTB: "Active",
//     CAL: "Active",
//     WTS: "Active",
//   });

//   const rows = useMemo(() => {
//     // In your real app, “Today” should filter by requested date.
//     const scope = typeScope[activeType];
//     return data.filter((r) => r.type === activeType).filter((r) => {
//       if (scope === "All") return true;
//       if (scope === "Today") return true;
//       return r.status === "Active";
//     });
//   }, [activeType, typeScope, data]);
//   const navigate = useNavigate();
// const toggleKeepAlive = (id: string) => {
//   setData((prev) =>
//     prev.map((row) =>
//       row.id === id ? { ...row, keepAlive: !row.keepAlive } : row,
//     ),
//   );
// };

//   const setScope = (t: "WTB" | "CAL" | "WTS", s: "Active" | "Today" | "All") => {
//     setTypeScope((p) => ({ ...p, [t]: s }));
//     setActiveType(t);
//   };

//   const deleteRow = (id: string) => {
//     alert(`Delete row id = ${id} (wire this to API)`);
//   };

//   return (
//     <div className="legacy-wrap">
//       {/* Header */}
//       <div className="flex items-center gap-x-2">
//         {/* <Button
//           icon={<LeftOutlined />}
//           size="small"
//           className="flex items-center justify-center border-gray-300"
//           onClick={() => navigate("/dashboard")}
//         /> */}
//         <h1 className="text-base sm:text-xl font-normal text-gray-700">
//           Quotes WTB
//         </h1>
//       </div>
//       <div className="legacy-top">
//         <div className="legacy-title">
//           <div className="legacy-title-text">WTB &amp; Calibration</div>
//           <div className="legacy-title-text">Listing</div>

//           <div className="legacy-left-actions">
//             <button className="legacy-btn">Back to MAT</button>
//             <button className="legacy-btn">NEW</button>
//           </div>
//         </div>

//         <div className="legacy-filters">
//           <FilterRow
//             label="WTB:"
//             value={typeScope.WTB}
//             onPick={(s) => setScope("WTB", s)}
//             active={activeType === "WTB"}
//           />
//           <FilterRow
//             label="CAL:"
//             value={typeScope.CAL}
//             onPick={(s) => setScope("CAL", s)}
//             active={activeType === "CAL"}
//           />
//           <FilterRow
//             label="WTS:"
//             value={typeScope.WTS}
//             onPick={(s) => setScope("WTS", s)}
//             active={activeType === "WTS"}
//             // screenshot shows only "Active" for WTS, but we keep consistent buttons
//           />
//         </div>

//         <div className="legacy-right">
//           <button className="legacy-btn legacy-sort">
//             Sort By... <CaretDownOutlined style={{ fontSize: 11 }} />
//           </button>

//           <div className="legacy-icons">
//             <span className="legacy-icon" title="Star">
//               <StarOutlined />
//             </span>
//             <span className="legacy-icon" title="Add">
//               <PlusSquareOutlined />
//             </span>
//             <span className="legacy-icon" title="Search">
//               <SearchOutlined />
//             </span>
//           </div>
//         </div>
//       </div>

//       {/* Table */}
//       <div className="legacy-table-wrap">
//         <table className="legacy-table">
//           <thead>
//             <tr>
//               <th style={{ width: 170 }}>Requested</th>
//               <th style={{ width: 170 }}>Manu</th>
//               <th style={{ width: 90 }}>Model</th>
//               <th>Options</th>
//               <th style={{ width: 90, textAlign: "center" }}>KeepAlive</th>
//               <th style={{ width: 90 }}>Status</th>
//               <th style={{ width: 70, textAlign: "center" }}>Priority</th>
//               <th style={{ width: 70, textAlign: "center" }}>Type</th>
//               <th style={{ width: 80 }}></th>
//               <th style={{ width: 120 }}></th>
//             </tr>
//           </thead>

//           <tbody>
//             {rows.map((r, idx) => (
//               <tr key={r.id} className={idx % 2 ? "alt" : ""}>
//                 <td>{r.requested}</td>
//                 <td>{r.manu}</td>
//                 <td>{r.model}</td>
//                 <td className="opts">{r.options}</td>
//                 <td style={{ textAlign: "center" }}>
//                   <input
//                     type="checkbox"
//                     checked={r.keepAlive}
//                     onChange={(e) => {
//                       const checked = e.target.checked;
//                       setData((prev) =>
//                         prev.map((row) =>
//                           row.id === r.id
//                             ? { ...row, keepAlive: checked }
//                             : row,
//                         ),
//                       );
//                     }}
//                     className="cursor-pointer"
//                   />
//                 </td>
//                 <td>{r.status}</td>
//                 <td style={{ textAlign: "center" }}>{r.priority}</td>
//                 <td style={{ textAlign: "center" }}>{r.type}</td>
//                 <td>
//                   <button
//                     className="legacy-btn legacy-del"
//                     onClick={() => deleteRow(r.id)}
//                   >
//                     Delete
//                   </button>
//                 </td>
//                 <td className="owner">{r.owner}</td>
//               </tr>
//             ))}

//             {/* empty filler rows to match “grid” look */}
//             {Array.from({ length: Math.max(0, 8 - rows.length) }).map(
//               (_, i) => (
//                 <tr
//                   key={`empty-${i}`}
//                   className={(rows.length + i) % 2 ? "alt" : ""}
//                 >
//                   <td>&nbsp;</td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                   <td style={{ textAlign: "center" }}></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                 </tr>
//               ),
//             )}
//           </tbody>
//         </table>
//       </div>

//       <style>{`
//         .legacy-wrap {
//           font-family: Arial, Helvetica, sans-serif;
//           background: #ffffff;
//           height: 100%;
//           width: 100%;
//         }

//         /* ===== top area ===== */
//         .legacy-top {
//           background: #dff4f6; /* light cyan like screenshot */
//           border-bottom: 1px solid #b7c9cc;
//           padding: 10px 14px;
//           display: grid;
//           grid-template-columns: 260px 1fr 250px;
//           gap: 10px;
//           align-items: start;
//         }

//         .legacy-title {
//           position: relative;
//         }
//         .legacy-title-text {
//           font-weight: 700;
//           font-size: 22px;
//           color: #1f2937;
//           line-height: 1.05;
//         }

//         .legacy-left-actions {
//           margin-top: 10px;
//           display: flex;
//           flex-direction: column;
//           gap: 6px;
//           width: 155px;
//         }

//         .legacy-filters {
//           display: flex;
//           flex-direction: column;
//           gap: 7px;
//           padding-top: 4px;
//         }

//         .legacy-right {
//           display: flex;
//           flex-direction: column;
//           align-items: flex-end;
//           gap: 10px;
//           padding-top: 2px;
//         }

//         .legacy-icons {
//           display: flex;
//           gap: 10px;
//           align-items: center;
//           padding-right: 4px;
//         }
//         .legacy-icon {
//           width: 26px;
//           height: 26px;
//           display: inline-flex;
//           align-items: center;
//           justify-content: center;
//           border: 1px solid #7b7b7b;
//           background: linear-gradient(#f5f5f5, #cfcfcf);
//           box-shadow: inset 0 1px 0 rgba(255,255,255,0.8);
//           border-radius: 2px;
//           cursor: pointer;
//           font-size: 15px;
//           color: #2f2f2f;
//         }
//         .legacy-icon:hover {
//           filter: brightness(1.02);
//         }

//         /* ===== legacy buttons (beveled) ===== */
//         .legacy-btn {
//           height: 26px;
//           padding: 0 10px;
//           font-size: 12px;
//           border: 1px solid #6f6f6f;
//           background: linear-gradient(#f3f3f3, #c8c8c8);
//           box-shadow: inset 0 1px 0 rgba(255,255,255,0.85);
//           border-radius: 2px;
//           color: #222;
//           cursor: pointer;
//           user-select: none;
//         }
//         .legacy-btn:active {
//           background: linear-gradient(#c8c8c8, #f3f3f3);
//         }
//         .legacy-btn.is-on {
//           background: linear-gradient(#e7e7e7, #b8b8b8);
//           border-color: #4b5563;
//           box-shadow: inset 0 1px 0 rgba(255,255,255,0.6);
//           font-weight: 700;
//         }

//         .legacy-sort {
//           min-width: 110px;
//           display: inline-flex;
//           align-items: center;
//           justify-content: center;
//           gap: 6px;
//         }

//         .legacy-del {
//           height: 22px;
//           padding: 0 10px;
//           font-size: 12px;
//         }

//         /* ===== filter row ===== */
//         .flt {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//         }
//         .flt label {
//           width: 44px;
//           font-size: 12px;
//           font-weight: 700;
//           color: #111827;
//         }
//         .flt .btns {
//           display: flex;
//           gap: 8px;
//         }

//         /* ===== table ===== */
//         .legacy-table-wrap {
//           padding: 0 10px 12px 10px;
//         }

//         .legacy-table {
//           width: 100%;
//           border-collapse: collapse;
//           table-layout: fixed;
//           font-size: 12px;
//         }

//         .legacy-table thead th {
//           text-align: left;
//           padding: 6px 6px;
//           border-bottom: 2px solid #9aa3a5;
//           color: #111827;
//           font-weight: 700;
//         }

//         .legacy-table tbody td {
//           padding: 6px 6px;
//           border-top: 1px solid #e5e7eb;
//           color: #111827;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .legacy-table tbody tr.alt {
//           background: #f2f2f2;
//         }

//         .legacy-table tbody tr:hover {
//           background: #eaf7ff;
//         }

//         .opts {
//           color: #111827;
//         }

//         .owner {
//           text-align: left;
//           padding-left: 20px;
//           color: #374151;
//         }

//         @media (max-width: 980px) {
//           .legacy-top {
//             grid-template-columns: 1fr;
//           }
//           .legacy-right {
//             align-items: flex-start;
//           }
//           .legacy-left-actions {
//             width: 200px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// const FilterRow: React.FC<{
//   label: string;
//   value: "Active" | "Today" | "All";
//   onPick: (v: "Active" | "Today" | "All") => void;
//   active?: boolean;
// }> = ({ label, value, onPick, active }) => {
//   return (
//     <div className="flt">
//       <label>{label}</label>
//       <div className="btns">
//         <button className={`legacy-btn ${value === "Active" && active ? "is-on" : ""}`} onClick={() => onPick("Active")}>
//           Active
//         </button>
//         <button className={`legacy-btn ${value === "Today" && active ? "is-on" : ""}`} onClick={() => onPick("Today")}>
//           Today&apos;s
//         </button>
//         <button className={`legacy-btn ${value === "All" && active ? "is-on" : ""}`} onClick={() => onPick("All")}>
//           All
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Quotes;
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import {
  StarOutlined,
  PlusSquareOutlined,
  SearchOutlined,
  // CaretDownOutlined,
  LeftOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { Button, Checkbox, DatePicker, Input, Modal, Pagination, Select, Table, message } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import {
  QuoteWtbListResponse,
  createQuoteWtb,
  createOutlookDraftFromTemplate,
  deleteQuoteWtb,
  getQuoteWtb,
  getManufacturers,
  sendQuoteEmail,
  updateQuoteWtb,
  bulkImportQuoteWtb,
  generateVendorToken,
} from "../../utils/API";
import { openOutlookDraft } from "../../utils/outlook";
import NavigationDropdown from "../../Components/NavigationDropDown";
import PageLogoutButton from "../../Components/PageLogoutButton";
import CommonHeader from "../../Components/commonHeader";
import { normalizeSortRules, sortRulesToQuery, type SortRule } from "../../utils/sortRules";

const WTB_EXPORT_COLUMNS = [
  { label: "Requested", key: "requested" },
  { label: "Manufacturer", key: "manu" },
  { label: "Model", key: "model" },
  { label: "Options", key: "options" },
  { label: "Status", key: "status" },
  { label: "Type", key: "type" },
  { label: "Keep Alive", key: "keepAlive" },
  { label: "Priority", key: "priority" },
  { label: "Source", key: "sourceuser" },
];

const WTB_SORT_KEYS = WTB_EXPORT_COLUMNS.map((column) => column.key);

const mailSendIcon = require("../../Assets/mailsendicon.png");

// Two WTB rows can hold different raw column values yet render as the very
// same "Manufacturer Model Options" line in the Want List email - the option
// text split differently between Model and Options, stray double spaces or a
// non-breaking space, or different casing. Keying on the rendered line keeps
// each model number in the email exactly once.
const wtbCleanField = (value: unknown): string =>
  String(value ?? "")
    .replace(/[  -​  　	]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const wtbItemKey = (item: { manu?: string; model?: string; options?: string }): string =>
  [wtbCleanField(item.manu), wtbCleanField(item.model), wtbCleanField(item.options)]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

const dedupeWtbRows = <T extends { manu?: string; model?: string; options?: string }>(
  items: T[],
): T[] => {
  const seen = new Set<string>();
  return items.filter((item) => {
    const key = wtbItemKey(item);
    if (!key) return true;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

type Row = {
  id: string;
  requested: string;
  manu: string;
  model: string;
  options: string;
  keepAlive: boolean;
  status: string;
  priority: number;
  type: "WTB" | "CAL" | "WTS" | string;
  source: string;
  isNew?: boolean;
};

const FindCell: React.FC<{
  value: string;
  onChange: (v: string) => void;
  onEnter: () => void;
  placeholder?: string;
  autoFocus?: boolean;
}> = ({ value, onChange, onEnter, placeholder, autoFocus }) => (
  <div style={{ position: "relative" }}>
    <Input
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onPressEnter={onEnter}
      placeholder={placeholder || "Search..."}
      autoFocus={autoFocus}
      style={{ height: 32, fontSize: 12, paddingRight: 24, borderColor: "#d9d9d9", borderRadius: 6 }}
    />
    <SearchOutlined style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", color: "#888", fontSize: 11, pointerEvents: "none" }} />
  </div>
);

type FindFields = { requested: string; manu: string; model: string; options: string; status: string; type: string };
const emptyFindFields: FindFields = { requested: "", manu: "", model: "", options: "", status: "", type: "" };

type WtbFindBarHandle = { submit: () => void };

const WtbFindBar = forwardRef<WtbFindBarHandle, {
  onFind: (fields: FindFields) => void;
  onCancel: () => void;
  manufacturerOptions: { value: string; label: string }[];
}>(({ onFind, onCancel, manufacturerOptions }, ref) => {
  const [fields, setFields] = useState<FindFields>(emptyFindFields);

  useImperativeHandle(ref, () => ({
    submit: () => {
      const hasAny = Object.values(fields).some((v) => v.trim());
      if (!hasAny) { message.warning("Enter at least one search value"); return; }
      onFind({ ...fields });
    },
  }));

  const handleEnter = () => {
    const hasAny = Object.values(fields).some((v) => v.trim());
    if (!hasAny) { message.warning("Enter at least one search value"); return; }
    onFind({ ...fields });
  };

  const tdStyle: React.CSSProperties = { padding: "4px 8px", verticalAlign: "middle", background: "transparent" };
  const fieldStyle: React.CSSProperties = { width: "100%", height: 32, fontSize: 12 };
  const selectCls = "!h-8 [&_.ant-select-selector]:!h-8 [&_.ant-select-selector]:!leading-8 [&_.ant-select-selection-item]:!leading-8 [&_.ant-select-selection-placeholder]:!leading-8";

  return (
    <tr style={{ borderBottom: "1px solid #d9d9d9" }}>
      <td style={{ ...tdStyle, paddingLeft: 20 }} />
      <td style={tdStyle}>
        <DatePicker
          size="small"
          format="MM/DD/YYYY"
          value={fields.requested ? dayjs(fields.requested) : undefined}
          onChange={(date) => setFields((p) => ({ ...p, requested: date ? date.format("MM/DD/YYYY") : "" }))}
          style={fieldStyle}
          allowClear
        />
      </td>
      <td style={tdStyle}>
        <Select
          size="small"
          showSearch
          allowClear
          value={fields.manu || undefined}
          placeholder="Search manu..."
          className={selectCls}
          style={fieldStyle}
          popupMatchSelectWidth={false}
          dropdownStyle={{ minWidth: 260 }}
          options={manufacturerOptions}
          filterOption={(input, option) =>
            String(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          onChange={(v) => setFields((p) => ({ ...p, manu: v || "" }))}
          autoFocus
        />
      </td>
      <td style={tdStyle}>
        <FindCell value={fields.model} onChange={(v) => setFields((p) => ({ ...p, model: v }))} onEnter={handleEnter} placeholder="Search model..." />
      </td>
      <td style={tdStyle}>
        <FindCell value={fields.options} onChange={(v) => setFields((p) => ({ ...p, options: v }))} onEnter={handleEnter} placeholder="Search options..." />
      </td>
      <td style={tdStyle} />
      <td style={tdStyle}>
        <Select
          size="small"
          value={fields.status || undefined}
          allowClear
          placeholder="Status..."
          className={selectCls}
          style={fieldStyle}
          onChange={(v) => setFields((p) => ({ ...p, status: v || "" }))}
          options={[
            { value: "Active", label: "Active" },
            { value: "Sent", label: "Sent" },
            { value: "Closed", label: "Closed" },
          ]}
        />
      </td>
      <td style={tdStyle} />
      <td style={tdStyle}>
        <Select
          size="small"
          value={fields.type || undefined}
          allowClear
          placeholder="Type..."
          className={selectCls}
          style={fieldStyle}
          onChange={(v) => setFields((p) => ({ ...p, type: v || "" }))}
          options={[
            { value: "WTB", label: "WTB" },
            { value: "CAL", label: "CAL" },
            { value: "WTS", label: "WTS" },
          ]}
        />
      </td>
      <td style={{ ...tdStyle, paddingRight: 20 }}>
        <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
          <button className="px-2 py-1 text-xs bg-blue-100 text-blue-700 border border-blue-300 hover:bg-blue-200 rounded" onClick={handleEnter}>Find</button>
          <button className="px-2 py-1 text-xs bg-gray-100 text-gray-600 border border-gray-300 hover:bg-gray-200 rounded" onClick={onCancel}>Cancel</button>
        </div>
      </td>
      <td style={tdStyle} />
    </tr>
  );
});

// Input field styling to match OpenOrder
// const inputStyle: React.CSSProperties = {
//   height: 28,
//   fontSize: 12,
//   borderRadius: 4,
//   border: "1px solid #A29F9F",
//   width: "100%",
// };

const labelStyle = "text-[12px] text-[#6C757D] mb-1 font-medium";
const inlineInputClass =
  "!h-8 !rounded-md !border !border-blue-200 !bg-blue-50/40 !px-2 !text-[12px] !text-gray-700 focus:!border-blue-400 focus:!bg-white";
const inlineSelectClass =
  "!h-8 !w-full !rounded-md !border !border-blue-200 !bg-blue-50/40 !text-[12px]";

// Content Components
const WTBContent: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <div className="mb-6 bg-white rounded-md border border-gray-200 shadow-sm">
      <div className="flex justify-between items-center p-4 border-b">
        <h3 className="text-base font-medium text-gray-800">WTB Report</h3>
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={onClose}
          className="hover:bg-gray-100"
          size="small"
        />
      </div>
      <div className="p-4 space-y-4">
        <p className="text-gray-600">
          WTB (Want to Buy) report shows items customers are looking to
          purchase.
        </p>
        <div className="flex justify-end gap-3 mt-4 pt-4 border-t">
          <Button onClick={onClose} size="small">
            Close
          </Button>
          <Button type="primary" size="small">
            Generate Report
          </Button>
        </div>
      </div>
    </div>
  );
};

const WTB_STATE_KEY = "quotesWtbState";
const loadWtbSavedState = () => {
  try { return JSON.parse(localStorage.getItem(WTB_STATE_KEY) || "null") || {}; } catch { return {}; }
};

const QuotesWtb: React.FC = () => {
  const _wtbSaved = useRef(loadWtbSavedState()).current;
  const wtbInitialRef = useRef(true);

  const [activeType, setActiveType] = useState<"WTB" | "CAL" | "WTS">(_wtbSaved.activeType || "WTB");
  const [data, setData] = useState<Row[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeContent, setActiveContent] = useState<string | null>(null);
  const [sortBy, setSortBy] = useState(_wtbSaved.sortBy || "date");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">(_wtbSaved.sortOrder || "desc");
  const [sortRules, setSortRules] = useState<SortRule[]>(() => normalizeSortRules(_wtbSaved.sortRules, WTB_SORT_KEYS));
  const [isSortModalOpen, setIsSortModalOpen] = useState(false);
  const [pendingSortBy, setPendingSortBy] = useState(_wtbSaved.sortBy || "date");
  const [pendingSortOrder, setPendingSortOrder] = useState<"asc" | "desc">(_wtbSaved.sortOrder || "desc");
  const [isFindMode, setIsFindMode] = useState(false);
  const [activeFilters, setActiveFilters] = useState<FindFields>(_wtbSaved.activeFilters || emptyFindFields);
  const [isFiltered, setIsFiltered] = useState(_wtbSaved.isFiltered || false);
  const [currentPage, setCurrentPage] = useState(_wtbSaved.currentPage || 1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedRowIdx, setSelectedRowIdx] = useState(0);
  const [recordInputValue, setRecordInputValue] = useState("");
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailTo, setEmailTo] = useState("");
  const [emailSubject, setEmailSubject] = useState("WTB Listing");
  const [emailSending, setEmailSending] = useState(false);
  const [calVendorLoading, setCalVendorLoading] = useState(false);
  const [wtbConfirmOpen, setWtbConfirmOpen] = useState(false);
  const [wtbConfirmIds, setWtbConfirmIds] = useState<string[]>([]);
  const [wtbConfirmSaving, setWtbConfirmSaving] = useState(false);
  const [wtbSelectModalOpen, setWtbSelectModalOpen] = useState(false);
  const [wtbSelectedIds, setWtbSelectedIds] = useState<string[]>([]);
  const [manufacturerOptions, setManufacturerOptions] = useState<{ value: string; label: string }[]>([]);
  const [editingRowId, setEditingRowId] = useState<string | null>(null);
  const [editingRowData, setEditingRowData] = useState<Row | null>(null);
  const [showAllTypes, setShowAllTypes] = useState(false);
  const navigate = useNavigate();
  const findBarRef = useRef<WtbFindBarHandle>(null);
  const reloadDataRef = useRef<() => void>(() => {});
  const buildSortParams = (rules = sortRules) => {
    const sort = sortRulesToQuery(rules, WTB_SORT_KEYS);
    return sort ? { sort } : {};
  };

  const [typeScope, setTypeScope] = useState<
    Record<"WTB" | "CAL" | "WTS", "Active" | "Today" | "All">
  >({
    WTB: "All",
    CAL: "All",
    WTS: "All",
  });

  const rows = useMemo(() => data, [data]);

  const setScope = (
    t: "WTB" | "CAL" | "WTS",
    s: "Active" | "Today" | "All",
  ) => {
    setShowAllTypes(false);
    setTypeScope((p) => ({ ...p, [t]: s }));
    setActiveType(t);
  };

  const mapWtbRows = (rowsToMap: any[]): Row[] =>
    rowsToMap.map((item, index) => {
      const rawDate = item?.created || item?.createdDate || item?.createdText;
      const parsedDate = rawDate ? new Date(rawDate) : null;
      const requested =
        parsedDate && !Number.isNaN(parsedDate.getTime())
          ? parsedDate.toLocaleString("en-US", {
              month: "2-digit",
              day: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            })
          : String(rawDate || "-");

      return {
        id: String(item?.id || item?.qid || index + 1),
        requested,
        manu: String(item?.eqBrand || item?.eqBrandConsolidated || "-"),
        model: String(item?.eqModel || "-"),
        options: String(item?.eqOptions || item?.options || ""),
        keepAlive:
          item?.keepAlive === true ||
          String(item?.keepAlive || "")
            .trim()
            .toLowerCase() === "true" ||
          String(item?.keepAlive || "")
            .trim()
            .toLowerCase() === "yes",
        status: String(item?.status || item?.sellerType || "Active"),
        priority: Number(item?.priority || 0),
        type: String(item?.type || item?.listType || activeType),
        source: String(item?.source || ""),
        isNew: false,
      };
    });

  const loadWtbRows = async (page = currentPage, limit = pageSize, filters = activeFilters) => {
    try {
      setIsLoading(true);
      const selectedScope = typeScope[activeType];
      const requestScope = selectedScope === "Today" ? "All" : selectedScope;
      const hasFilter = Object.values(filters).some((v) => v.trim());
      const response = await getQuoteWtb({
        ...(!hasFilter && !showAllTypes ? { type: activeType, listType: activeType } : {}),
        scope: hasFilter ? "All" : requestScope,
        sortBy,
        order: sortOrder,
        ...buildSortParams(),
        page,
        limit,
        ...(filters.requested.trim()
          ? (() => {
              const d = dayjs(filters.requested.trim(), [
                "MM/DD/YYYY hh:mm:ss A",
                "MM/DD/YYYY HH:mm:ss",
                "MM/DD/YYYY",
              ]);
              return d.isValid() ? { requested: d.format("YYYY-MM-DD") } : {};
            })()
          : {}),
        ...(filters.model.trim() ? { model: filters.model.trim() } : {}),
        ...(filters.manu.trim() ? { manu: filters.manu.trim() } : {}),
        ...(filters.options.trim() ? { options: filters.options.trim() } : {}),
        ...(filters.status.trim() ? { status: filters.status.trim() } : {}),
        ...(filters.type.trim() ? { type: filters.type.trim() } : {}),
      });

      const apiRows = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : [];

      const total = (response as QuoteWtbListResponse)?.pagination?.total ?? apiRows.length;
      setTotalRecords(total);

      const rowsForScope =
        selectedScope === "Today"
          ? apiRows.filter((item: any) => {
              const rawDate =
                item?.created || item?.createdDate || item?.createdText;
              const parsed = rawDate ? new Date(rawDate) : null;
              if (!parsed || Number.isNaN(parsed.getTime())) return false;
              const today = new Date();
              return (
                parsed.getFullYear() === today.getFullYear() &&
                parsed.getMonth() === today.getMonth() &&
                parsed.getDate() === today.getDate()
              );
            })
          : apiRows;

      setData(mapWtbRows(rowsForScope));
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to load Quotes WTB");
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  reloadDataRef.current = () => loadWtbRows(currentPage, pageSize, activeFilters);

  const stableOnFind = useCallback((fields: FindFields) => {
    setActiveFilters({ ...fields });
    setIsFiltered(true);
    setIsFindMode(false);
    setCurrentPage(1);
  }, []);

  const stableOnCancel = useCallback(() => {
    setIsFindMode(false);
    reloadDataRef.current();
  }, []);

  const tableComponents = useMemo(() => ({
    header: {
      wrapper: ({ children, ...rest }: any) => (
        <thead {...rest}>
          {children}
          {isFindMode && <WtbFindBar ref={findBarRef} onFind={stableOnFind} onCancel={stableOnCancel} manufacturerOptions={manufacturerOptions} />}
        </thead>
      ),
    },
  }), [isFindMode, stableOnFind, stableOnCancel, manufacturerOptions]);

  useEffect(() => {
    getManufacturers()
      .then((data: any) => {
        const list = Array.isArray(data) ? data : [];
        setManufacturerOptions(list.map((m: any) => ({ value: m.name, label: m.name })));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!wtbInitialRef.current) {
      localStorage.setItem(WTB_STATE_KEY, JSON.stringify({ activeType, sortBy, sortOrder, sortRules, activeFilters, isFiltered, currentPage }));
    }
  }, [activeType, sortBy, sortOrder, sortRules, activeFilters, isFiltered, currentPage]);

  useEffect(() => {
    if (wtbInitialRef.current) {
      wtbInitialRef.current = false;
      loadWtbRows(_wtbSaved.currentPage || 1, pageSize, _wtbSaved.activeFilters || emptyFindFields);
      return;
    }
    setCurrentPage(1);
    loadWtbRows(1, pageSize, activeFilters);
  }, [activeType, typeScope, sortBy, sortOrder, sortRules, activeFilters, showAllTypes]);

  useEffect(() => {
    if (wtbInitialRef.current) return;
    loadWtbRows(currentPage, pageSize, activeFilters);
  }, [currentPage, pageSize]);

  // const handleButtonClick = (type: string) => {
  //   if (activeContent === type) {
  //     setActiveContent(null);
  //   } else {
  //     setActiveContent(type);
  //   }
  // };

  const handleCloseContent = () => {
    setActiveContent(null);
  };

  const renderContent = () => {
    switch (activeContent) {
      case "wtb":
        return <WTBContent onClose={handleCloseContent} />;
      default:
        return null;
    }
  };

  const deleteRow = async (id: string) => {
    const target = data.find((row) => row.id === id);
    if (target?.isNew) {
      setData((prev) => prev.filter((row) => row.id !== id));
      return;
    }
    try {
      await deleteQuoteWtb(id);
      setData((prev) => prev.filter((row) => row.id !== id));
      // message.success("WTB record deleted");
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to delete WTB record");
    }
  };

  const handleCreateNewRecord = async () => {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const d = String(now.getDate()).padStart(2, "0");
    const hh = String(now.getHours()).padStart(2, "0");
    const mm = String(now.getMinutes()).padStart(2, "0");
    const ss = String(now.getSeconds()).padStart(2, "0");
    const createdValue = `${m}/${d}/${y} ${hh}:${mm}:${ss}`;
    const localId = `new-${Date.now()}`;
    setData((prev) => [
      {
        id: localId,
        requested: createdValue,
        manu: "",
        model: "",
        options: "",
        keepAlive: false,
        status: "Active",
        priority: 5,
        type: activeType,
        source: "",
        isNew: true,
      },
      ...prev,
    ]);
  };

  const handleRowChange = (
    rowId: string,
    field: keyof Row,
    value: string | number | boolean,
  ) => {
    setData((prev) =>
      prev.map((row) => (row.id === rowId ? { ...row, [field]: value } : row)),
    );
  };

  useEffect(() => {
    setRecordInputValue(data.length > 0 ? String(selectedRowIdx + 1) : "");
  }, [selectedRowIdx, data.length]);

  const handleRecordInputCommit = (value: string) => {
    const parsed = Number.parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed < 1 || parsed > data.length) {
      setRecordInputValue(data.length > 0 ? String(selectedRowIdx + 1) : "");
      return;
    }
    setSelectedRowIdx(parsed - 1);
  };

  const handleDeleteSelected = async () => {
    if (data.length === 0) {
      message.warning("No record selected to delete");
      return;
    }
    const target = data[selectedRowIdx];
    if (!target) return;
    const confirmed = window.confirm("Delete this WTB record?");
    if (!confirmed) return;
    await deleteRow(target.id);
    setSelectedRowIdx((idx) => Math.max(0, Math.min(idx, data.length - 2)));
  };

  const buildEmailHtml = (vendorFormUrl = "") => {
    const linkBlock = vendorFormUrl
      ? `<div style="font-family:Arial,sans-serif;font-size:14px;margin-bottom:16px">
           <a href="${vendorFormUrl}" style="display:inline-block;background:#004AAD;color:#fff;padding:10px 18px;border-radius:4px;text-decoration:none;font-weight:600">Submit Your Quote</a>
           <div style="font-size:12px;color:#666;margin-top:6px">Or copy this link: ${vendorFormUrl}</div>
         </div>`
      : "";
    const rowsHtml = rows
      .map(
        (r, i) => `
        <tr style="background:${i % 2 === 0 ? "#ffffff" : "#f9f9f9"}">
          <td style="padding:6px 10px;border:1px solid #ddd">${r.requested}</td>
          <td style="padding:6px 10px;border:1px solid #ddd">${r.manu}</td>
          <td style="padding:6px 10px;border:1px solid #ddd">${r.model}</td>
          <td style="padding:6px 10px;border:1px solid #ddd">${r.options}</td>
          <td style="padding:6px 10px;border:1px solid #ddd;text-align:center">${r.keepAlive ? "Yes" : "No"}</td>
          <td style="padding:6px 10px;border:1px solid #ddd">${r.status}</td>
          <td style="padding:6px 10px;border:1px solid #ddd;text-align:center">${r.priority}</td>
          <td style="padding:6px 10px;border:1px solid #ddd;text-align:center">${r.type}</td>
        </tr>`,
      )
      .join("");

    return `
      <div style="font-family:Arial,sans-serif;font-size:13px;color:#222">
        <h2 style="margin-bottom:8px">WTB &amp; Calibration Listing</h2>
        <p style="margin-bottom:16px;color:#555">Total records: <strong>${rows.length}</strong></p>
        ${linkBlock}
        <table style="border-collapse:collapse;width:100%;min-width:700px">
          <thead>
            <tr style="background:#004AAD;color:#fff">
              <th style="padding:8px 10px;border:1px solid #003a8c;text-align:left">Requested</th>
              <th style="padding:8px 10px;border:1px solid #003a8c;text-align:left">Manufacturer</th>
              <th style="padding:8px 10px;border:1px solid #003a8c;text-align:left">Model</th>
              <th style="padding:8px 10px;border:1px solid #003a8c;text-align:left">Options</th>
              <th style="padding:8px 10px;border:1px solid #003a8c;text-align:center">Keep Alive</th>
              <th style="padding:8px 10px;border:1px solid #003a8c;text-align:left">Status</th>
              <th style="padding:8px 10px;border:1px solid #003a8c;text-align:center">Priority</th>
              <th style="padding:8px 10px;border:1px solid #003a8c;text-align:center">Type</th>
            </tr>
          </thead>
          <tbody>${rowsHtml}</tbody>
        </table>
      </div>`;
  };

  const handleSendEmail = async () => {
    if (!emailTo.trim()) { message.warning("Please enter a recipient email address"); return; }
    if (!rows.length) { message.warning("No records to send"); return; }
    try {
      setEmailSending(true);
      // Generate a per-email vendor token (valid 2 months) for the submit link.
      let vendorFormUrl = "";
      try {
        const tok = await generateVendorToken({
          baseUrl: window.location.origin,
          items: rows.map((r) => ({ brand: r.manu, model: r.model, options: r.options })),
        });
        vendorFormUrl = tok.url;
      } catch { /* non-fatal: send listing without the submit link */ }
      await sendQuoteEmail({
        to: emailTo.trim(),
        subject: emailSubject.trim() || "WTB Listing",
        html: buildEmailHtml(vendorFormUrl),
      });
      message.success("Email sent successfully");
      setShowEmailModal(false);
      setEmailTo("");
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to send email");
    } finally {
      setEmailSending(false);
    }
  };

  const getCurrentUserEmail = (): string => {
    try {
      const stored = JSON.parse(localStorage.getItem("user") || "{}");
      return (stored?.email || "").trim().toLowerCase();
    } catch {
      return "";
    }
  };

  const wtbConfirmEmails = (process.env.REACT_APP_WTB_CONFIRM_EMAILS || "")
    .split(",")
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean);

  const handleOpenEmailCalVendorSelect = () => {
    if (!rows.length) { message.warning("No records to send"); return; }
    const currentEmail = getCurrentUserEmail();
    if (!wtbConfirmEmails.includes(currentEmail)) {
      handleEmailCalVendor(rows);
      return;
    }
    setWtbSelectedIds(rows.map((r) => r.id).filter(Boolean));
    setWtbSelectModalOpen(true);
  };

  const handleEmailCalVendor = async (rowsOverride?: Row[]) => {
    const pickedRows = rowsOverride ?? rows.filter((r) => wtbSelectedIds.includes(r.id));
    // Print each distinct equipment line once, but still mark every picked
    // record as Sent afterwards.
    const selectedRows = dedupeWtbRows(pickedRows);
    if (!selectedRows.length) { message.warning("No records selected to send"); return; }
    try {
      setCalVendorLoading(true);
      setWtbSelectModalOpen(false);
      // Generate a per-email vendor token (valid 2 months) for the submit link.
      let vendorFormUrl = "";
      try {
        const tok = await generateVendorToken({
          baseUrl: window.location.origin,
          items: selectedRows.map((r) => ({ brand: r.manu, model: r.model, options: r.options })),
        });
        vendorFormUrl = tok.url;
      } catch { /* non-fatal: send draft without the submit link */ }
      const draftResponse = await createOutlookDraftFromTemplate({
        templateSlug: "email-to-calibration-vendor",
        customItems: selectedRows.map((r) => ({ eqBrand: r.manu, eqModel: r.model, eqOptions: r.options })),
        to: "dealers@alliancetesteq.com",
        launchMode: "desktop",
        vendorFormUrl,
        todayDate: new Date().toLocaleDateString("en-US", { month: "numeric", day: "numeric", year: "numeric" }),
      });
      await openOutlookDraft(draftResponse);
      const recordIds = pickedRows.map((r) => r.id).filter(Boolean);
      setWtbConfirmIds(recordIds);
      setTimeout(() => setWtbConfirmOpen(true), 5000);
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to prepare calibration vendor email");
    } finally {
      setCalVendorLoading(false);
    }
  };

  const handleOpenFind = () => {
    setIsFindMode(true);
    setData([]);
  };

  const handleCancelFind = () => {
    setIsFindMode(false);
    loadWtbRows(currentPage, pageSize, activeFilters);
  };

  const handlePerformFind = () => {
    findBarRef.current?.submit();
  };

  const handleShowAll = () => {
    setActiveFilters(emptyFindFields);
    setIsFiltered(false);
    setIsFindMode(false);
    setShowAllTypes(true);
    setSortRules([]);
    setTypeScope({ WTB: "All", CAL: "All", WTS: "All" });
    localStorage.setItem(WTB_STATE_KEY, JSON.stringify({ activeType, sortBy, sortOrder, sortRules: [], activeFilters: emptyFindFields, isFiltered: false, currentPage: 1 }));
  };

  const handleOpenSortModal = () => {
    setPendingSortBy(sortBy);
    setPendingSortOrder(sortOrder);
    setIsSortModalOpen(true);
  };

  const handleApplySort = () => {
    setSortBy(pendingSortBy);
    setSortOrder(pendingSortOrder);
    const legacyField = pendingSortBy === "date" ? "requested" : pendingSortBy === "manufacturer" ? "manu" : pendingSortBy;
    setSortRules([{ field: legacyField, direction: pendingSortOrder }]);
    setIsSortModalOpen(false);
  };

  const handleApplySortRules = async (rules: SortRule[]) => {
    const normalized = normalizeSortRules(rules, WTB_SORT_KEYS);
    setSortRules(normalized);
    setCurrentPage(1);
  };

  const handleStartEdit = (record: Row) => {
    if (record.isNew) return;
    setEditingRowId(record.id);
    setEditingRowData({ ...record });
  };

  const handleEditChange = (field: keyof Row, value: string | number | boolean) => {
    setEditingRowData((prev) => (prev ? { ...prev, [field]: value } : prev));
  };

  const handleSaveEdit = async () => {
    if (!editingRowId || !editingRowData) return;
    try {
      await updateQuoteWtb(editingRowId, {
        created: editingRowData.requested,
        eqBrand: editingRowData.manu,
        eqModel: editingRowData.model,
        eqOptions: editingRowData.options,
        status: editingRowData.status,
        type: editingRowData.type,
        listType: editingRowData.type,
        keepAlive: editingRowData.keepAlive,
        priority: Number(editingRowData.priority) || 0,
        source: editingRowData.source,
      });
      setData((prev) =>
        prev.map((row) => (row.id === editingRowId ? { ...editingRowData } : row)),
      );
      setEditingRowId(null);
      setEditingRowData(null);
      message.success("Record updated");
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to update record");
    }
  };

  const handleCancelEdit = () => {
    setEditingRowId(null);
    setEditingRowData(null);
  };

  const handleSaveNewRow = async (row: Row) => {
    if (!row.manu.trim() && !row.model.trim()) {
      message.warning("Please enter Manufacturer or Model before saving.");
      return;
    }
    try {
      const created = await createQuoteWtb({
        created: row.requested,
        eqBrand: row.manu,
        eqModel: row.model,
        eqOptions: row.options,
        status: row.status || "Active",
        type: row.type || activeType,
        listType: row.type || activeType,
        keepAlive: row.keepAlive,
        priority: Number(row.priority) || 0,
        source: row.source,
      });
      const persistedId = String(created?.id || created?.qid || row.id);
      setData((prev) =>
        prev.map((item) =>
          item.id === row.id ? { ...item, id: persistedId, isNew: false } : item,
        ),
      );
      // message.success("Record saved");
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to save record");
    }
  };

  return (
    <div className="quotes-wtb-page bg-slate-50 min-h-screen overflow-x-hidden">
      <CommonHeader
        className="mb-0"
        currentRecord={recordInputValue}
        disableNext={data.length === 0 || selectedRowIdx >= data.length - 1}
        disablePrevious={selectedRowIdx <= 0 || data.length === 0}
        onDeleteRecord={handleDeleteSelected}
        onFind={handleOpenFind}
        isFindMode={isFindMode}
        onCancelFind={handleCancelFind}
        onPerformFind={handlePerformFind}
        onNewRecord={handleCreateNewRecord}
        onNextRecord={() => setSelectedRowIdx((idx) => Math.min(idx + 1, data.length - 1))}
        onPreviousRecord={() => setSelectedRowIdx((idx) => Math.max(idx - 1, 0))}
        onRecordChange={setRecordInputValue}
        onRecordCommit={handleRecordInputCommit}
        onRecordSliderCommit={(index) => setSelectedRowIdx(index)}
        onShowAll={handleShowAll}
        recordCount={data.length}
        recordIndex={Math.min(selectedRowIdx, Math.max(data.length - 1, 0))}
        rightContent={<PageLogoutButton className="quotes-wtb-logout-btn" />}
        totalActiveCount={data.length}
        totalLabel={isFiltered ? "Filtered" : (sortRules.length > 0 ? "Total (Sorted)" : "Total (Unsorted)")}
        totalRecordCount={totalRecords}
        totalValue={isFiltered ? `${data.length} / ${totalRecords}` : totalRecords}
        sortColumns={WTB_EXPORT_COLUMNS}
        sortTitle="Sort Quotes WTB Records"
        sortRules={sortRules}
        onApplySort={handleApplySortRules}
        exportColumns={WTB_EXPORT_COLUMNS}
        getData={() => data}
        onImport={async (rows) => {
          const mapped = rows.map((r) => {
            const { sourceuser, ...rest } = r;
            return { ...rest, source: sourceuser ?? "" };
          });
          await bulkImportQuoteWtb(mapped);
        }}
        exportFilename="quotes-wtb"
      />
      {/* Top Navigation & Header with Filters */}
      <div className="mb-4">
        <div className="overflow-x-auto border border-gray-400 bg-[#e6f6f8] px-2 py-1">
          <div className="flex min-w-[1120px] items-start gap-10">
            <div className="flex w-[260px] flex-col items-center pt-1">
              <h1 className="text-center text-[18px] font-bold leading-[1.05] text-black">
                WTB &amp; Calibration
                <br />
                Listing
              </h1>
              <div className="mt-2 flex w-[100px] flex-col gap-2">
                <Button
                  type="primary"
                  size="small"
                  className="h-[22px] whitespace-nowrap rounded bg-[#004AAD] px-2 py-0 text-[12px] leading-none text-white hover:bg-blue-700"
                >
                  Back to MAT
                </Button>

                <Button
                  type="primary"
                  size="small"
                  className={`px-4 py-1.5 text-sm rounded bg-[#004AAD] text-white hover:bg-blue-700`}
                  onClick={handleCreateNewRecord}
                >
                  NEW
                </Button>
              </div>
            </div>

            <div className="flex flex-col gap-3 pt-1">
              <div className="flex items-center gap-2">
                <span className={labelStyle}>WTB:</span>
                <div className="flex gap-1">
                  <button
                    className={`filter-toggle-btn px-3 py-1 text-xs rounded ${
                      typeScope.WTB === "Active" && activeType === "WTB"
                        ? "filter-toggle-active"
                        : ""
                    }`}
                    onClick={() => setScope("WTB", "Active")}
                  >
                    Active
                  </button>

                  <button
                    className={`filter-toggle-btn px-3 py-1 text-xs rounded ${
                      typeScope.WTB === "Today" && activeType === "WTB"
                        ? "filter-toggle-active"
                        : ""
                    }`}
                    onClick={() => setScope("WTB", "Today")}
                  >
                    Today's
                  </button>

                  <button
                    className={`filter-toggle-btn px-3 py-1 text-xs rounded ${
                      typeScope.WTB === "All" && activeType === "WTB"
                        ? "filter-toggle-active"
                        : ""
                    }`}
                    onClick={() => setScope("WTB", "All")}
                  >
                    All
                  </button>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <span className={labelStyle}>CAL:</span>
                <div className="flex gap-1">
                  <button
                    className={`filter-toggle-btn px-3 py-1 text-xs rounded ${
                      typeScope.CAL === "Active" && activeType === "CAL"
                        ? "filter-toggle-active"
                        : ""
                    }`}
                    onClick={() => setScope("CAL", "Active")}
                  >
                    Active
                  </button>

                  <button
                    className={`filter-toggle-btn px-3 py-1 text-xs rounded ${
                      typeScope.CAL === "Today" && activeType === "CAL"
                        ? "filter-toggle-active"
                        : ""
                    }`}
                    onClick={() => setScope("CAL", "Today")}
                  >
                    Today's
                  </button>

                  <button
                    className={`filter-toggle-btn px-3 py-1 text-xs rounded ${
                      typeScope.CAL === "All" && activeType === "CAL"
                        ? "filter-toggle-active"
                        : ""
                    }`}
                    onClick={() => setScope("CAL", "All")}
                  >
                    All
                  </button>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <span className={labelStyle}>WTS:</span>
                <div className="flex gap-1">
                  <button
                    className={`filter-toggle-btn px-3 py-1 text-xs rounded ${
                      typeScope.WTS === "Active" && activeType === "WTS"
                        ? "filter-toggle-active"
                        : ""
                    }`}
                    onClick={() => setScope("WTS", "Active")}
                  >
                    Active
                  </button>

                  <button
                    className={`filter-toggle-btn px-3 py-1 text-xs rounded ${
                      typeScope.WTS === "Today" && activeType === "WTS"
                        ? "filter-toggle-active"
                        : ""
                    }`}
                    onClick={() => setScope("WTS", "Today")}
                  >
                    Today's
                  </button>

                  <button
                    className={`filter-toggle-btn px-3 py-1 text-xs rounded ${
                      typeScope.WTS === "All" && activeType === "WTS"
                        ? "filter-toggle-active"
                        : ""
                    }`}
                    onClick={() => setScope("WTS", "All")}
                  >
                    All
                  </button>
                </div>
              </div>
            </div>

            <div className="flex flex-1 items-start justify-between pt-1">
              <div className="flex flex-col gap-3">
                <Button
                  type="primary"
                  size="small"
                  className="flex items-center justify-center bg-[#004AAD] text-white border border-gray-300 rounded"
                  onClick={handleOpenSortModal}
                >
                  Sort By...
                </Button>
              </div>

              <div className="flex flex-col items-center gap-2 pr-4 pt-10">
                <div className="flex items-center gap-2">
                  <Button
                    type="primary"
                    icon={!calVendorLoading && <img src={mailSendIcon} style={{ width: 56, height: 56, objectFit: "contain", verticalAlign: "middle", marginTop: -4 }} />}
                    className="flex items-center justify-center bg-[#004AAD] text-white border border-gray-300 rounded"
                    size="large"
                    loading={calVendorLoading}
                    onClick={handleOpenEmailCalVendorSelect}
                  />
                  <Button
                    type="primary"
                    icon={<PlusSquareOutlined />}
                    className="flex items-center justify-center bg-[#004AAD] text-white border border-gray-300 rounded"
                    size="large"
                    title="Add"
                    onClick={handleCreateNewRecord}
                  />
                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    className="flex items-center justify-center bg-[#004AAD] text-white border border-gray-300 rounded"
                    size="large"
                    title="Find"
                    onClick={handleOpenFind}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={wtbSelectModalOpen}
        onCancel={() => setWtbSelectModalOpen(false)}
        footer={null}
        centered
        width={960}
        closeIcon={<span style={{ color: "#fff", fontSize: 18 }}>&times;</span>}
        styles={{ body: { padding: 0 }, content: { padding: 0, overflow: "hidden", borderRadius: 10 } }}
      >
        <div style={{ background: "#1f2937", padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 600, color: "#fff" }}>Select Records to Include</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.75)", marginTop: 2 }}>
              Choose which WTB records to send in the Outlook draft
            </div>
          </div>
        </div>

        <div style={{ padding: "16px 24px 0" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingBottom: 12,
              marginBottom: 4,
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <Checkbox
              indeterminate={wtbSelectedIds.length > 0 && wtbSelectedIds.length < rows.length}
              checked={rows.length > 0 && wtbSelectedIds.length === rows.length}
              onChange={(e) => setWtbSelectedIds(e.target.checked ? rows.map((r) => r.id).filter(Boolean) : [])}
            >
              <span style={{ fontWeight: 500 }}>Select All</span>
            </Checkbox>
            <span style={{ fontSize: 12, color: "#8c8c8c" }}>{rows.length} record{rows.length === 1 ? "" : "s"} total</span>
          </div>

          <div style={{ maxHeight: 460, overflowY: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr style={{ background: "#f5f7fa" }}>
                  <th style={{ padding: "10px 12px", textAlign: "left", width: 40, position: "sticky", top: 0, background: "#f5f7fa", zIndex: 1 }} />
                  <th style={{ padding: "10px 12px", textAlign: "left", position: "sticky", top: 0, background: "#f5f7fa", zIndex: 1, color: "#595959", fontWeight: 600 }}>Requested</th>
                  <th style={{ padding: "10px 12px", textAlign: "left", position: "sticky", top: 0, background: "#f5f7fa", zIndex: 1, color: "#595959", fontWeight: 600 }}>Manufacturer</th>
                  <th style={{ padding: "10px 12px", textAlign: "left", position: "sticky", top: 0, background: "#f5f7fa", zIndex: 1, color: "#595959", fontWeight: 600 }}>Model</th>
                  <th style={{ padding: "10px 12px", textAlign: "left", position: "sticky", top: 0, background: "#f5f7fa", zIndex: 1, color: "#595959", fontWeight: 600 }}>Options</th>
                  <th style={{ padding: "10px 12px", textAlign: "center", position: "sticky", top: 0, background: "#f5f7fa", zIndex: 1, color: "#595959", fontWeight: 600, width: 90 }}>Type</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, i) => {
                  const checked = wtbSelectedIds.includes(r.id);
                  return (
                    <tr
                      key={r.id}
                      style={{
                        borderTop: "1px solid #f0f0f0",
                        background: checked ? (i % 2 === 0 ? "#ffffff" : "#f9fbff") : "#fafafa",
                        color: checked ? "#222" : "#b0b0b0",
                        transition: "background-color 0.15s ease",
                      }}
                    >
                      <td style={{ padding: "10px 12px" }}>
                        <Checkbox
                          checked={checked}
                          onChange={(e) =>
                            setWtbSelectedIds((prev) =>
                              e.target.checked ? [...prev, r.id] : prev.filter((id) => id !== r.id),
                            )
                          }
                        />
                      </td>
                      <td style={{ padding: "10px 12px", whiteSpace: "nowrap" }}>{r.requested}</td>
                      <td style={{ padding: "10px 12px" }}>{r.manu}</td>
                      <td style={{ padding: "10px 12px" }}>{r.model}</td>
                      <td style={{ padding: "10px 12px" }}>{r.options}</td>
                      <td style={{ padding: "10px 12px", textAlign: "center" }}>
                        <span
                          style={{
                            display: "inline-block",
                            fontSize: 11,
                            fontWeight: 600,
                            padding: "2px 8px",
                            borderRadius: 999,
                            background: checked ? "#e9ebee" : "#f0f0f0",
                            color: checked ? "#1f2937" : "#b0b0b0",
                          }}
                        >
                          {r.type}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            padding: "16px 24px",
            marginTop: 16,
            borderTop: "1px solid #e5e7eb",
            background: "#fafafa",
          }}
        >
          <Button onClick={() => setWtbSelectModalOpen(false)}>Cancel</Button>
          <Button
            type="primary"
            loading={calVendorLoading}
            disabled={!wtbSelectedIds.length}
            onClick={() => handleEmailCalVendor()}
            style={{ background: "#1f2937", borderColor: "#1f2937" }}
            onMouseEnter={(e) => {
              if (!wtbSelectedIds.length) return;
              e.currentTarget.style.background = "#374151";
              e.currentTarget.style.borderColor = "#374151";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#1f2937";
              e.currentTarget.style.borderColor = "#1f2937";
            }}
          >
            Send to Outlook ({wtbSelectedIds.length})
          </Button>
        </div>
      </Modal>

      <Modal
        open={wtbConfirmOpen}
        onCancel={() => setWtbConfirmOpen(false)}
        footer={null}
        closable={false}
        centered
        width={340}
        styles={{ body: { padding: "18px 20px 14px" } }}
        title={
          <div style={{ fontSize: 13, fontWeight: 600, color: "#fff", background: "#6b7280", margin: "-20px -24px 0", padding: "8px 16px", borderRadius: "8px 8px 0 0" }}>
            WTB Sending Confirmation
          </div>
        }
      >
        <p style={{ fontSize: 13, margin: "12px 0 18px", color: "#222" }}>
          Are you sure you sent the WTB Successfully?
        </p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <Button
            size="small"
            style={{ minWidth: 50 }}
            onClick={() => setWtbConfirmOpen(false)}
          >
            No
          </Button>
          <Button
            type="primary"
            size="small"
            style={{ minWidth: 50, background: "#6b7280", borderColor: "#6b7280" }}
            loading={wtbConfirmSaving}
            onClick={async () => {
              setWtbConfirmSaving(true);
              try {
                await Promise.all(wtbConfirmIds.map((id) => updateQuoteWtb(id, { status: "Sent" })));
                message.success("Records marked as Sent");
                setWtbConfirmOpen(false);
                loadWtbRows(currentPage, pageSize, activeFilters);
              } catch {
                message.error("Failed to update record statuses");
              } finally {
                setWtbConfirmSaving(false);
              }
            }}
          >
            Yes
          </Button>
        </div>
      </Modal>

      <Modal
        title="Sort WTB Listing"
        open={isSortModalOpen}
        onCancel={() => setIsSortModalOpen(false)}
        footer={null}
        width={340}
      >
        <div className="space-y-4 pt-2">
          <div className="flex items-center gap-3">
            <span className={`${labelStyle} min-w-[58px] !mb-0`}>Sort By:</span>
            <Select
              className="flex-1"
              size="small"
              value={pendingSortBy}
              options={[
                { value: "date", label: "Date" },
                { value: "priority", label: "Priority" },
                { value: "status", label: "Status" },
              ]}
              onChange={(value) => setPendingSortBy(value)}
            />
          </div>
          <div className="flex items-center gap-3">
            <span className={`${labelStyle} min-w-[58px] !mb-0`}>Order:</span>
            <Select
              className="flex-1"
              size="small"
              value={pendingSortOrder}
              options={[
                { value: "desc", label: "DESC" },
                { value: "asc", label: "ASC" },
              ]}
              onChange={(value) => setPendingSortOrder(value)}
            />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button size="small" onClick={() => setIsSortModalOpen(false)}>
              Cancel
            </Button>
            <Button
              size="small"
              className="!bg-[#c7c7c7] !border-[#6f6f6f] !text-black hover:!bg-[#c7c7c7] hover:!border-[#6f6f6f] hover:!text-black focus:!bg-[#c7c7c7] focus:!border-[#6f6f6f] focus:!text-black"
              onClick={handleApplySort}
            >
              Sort
            </Button>
          </div>
        </div>
      </Modal>

      {/* Content Panel */}
      {renderContent()}

      {/* Main Table Grid */}
      <div className="bg-white rounded-[24px] border border-gray-200 p-6 shadow-sm">
        <h3 className="text-lg font-medium text-gray-800 mb-6 ml-3">Listing</h3>

        {/* Table Wrapper */}
        <div className="rounded-xl overflow-hidden mx-3">
          <Table
            components={tableComponents}
            dataSource={rows}
            columns={[
              {
                title: "#",
                key: "index",
                align: "left",
                width: "4%",
                render: (_, __, index) => index + 1,
                onHeaderCell: () => ({
                  style: {
                    backgroundColor: "#DFEFFF",
                    color: "black",
                    fontWeight: "600",
                    paddingLeft: "20px",
                    fontSize: "14px",
                  },
                }),
                onCell: () => ({
                  style: { paddingLeft: "20px", fontWeight: "400" },
                }),
              },
              {
                title: "Requested",
                dataIndex: "requested",
                key: "requested",
                align: "left",
                width: "12%",
                onHeaderCell: () => ({
                  style: {
                    backgroundColor: "#DFEFFF",
                    color: "black",
                    fontWeight: "600",
                    fontSize: "14px",
                  },
                }),
                render: (value, record) => {
                  if (record.isNew) {
                    return (
                      <Input
                        size="small"
                        value={record.requested}
                        className={inlineInputClass}
                        onChange={(e) => handleRowChange(record.id, "requested", e.target.value)}
                      />
                    );
                  }
                  if (record.id === editingRowId && editingRowData) {
                    const parsedDate = editingRowData.requested
                      ? dayjs(editingRowData.requested, [
                          "MM/DD/YYYY hh:mm:ss A",
                          "MM/DD/YYYY HH:mm:ss",
                          "MM/DD/YYYY, hh:mm:ss A",
                          "M/D/YYYY, h:mm:ss A",
                          "MM/DD/YYYY",
                        ])
                      : undefined;
                    const applyDate = (date: any) => {
                      if (!date) { handleEditChange("requested", ""); return; }
                      handleEditChange("requested", date.format("MM/DD/YYYY hh:mm:ss A"));
                    };
                    return (
                      <DatePicker
                        size="small"
                        showTime={{ use12Hours: true, format: "hh:mm:ss A" }}
                        format="MM/DD/YYYY hh:mm:ss A"
                        value={parsedDate?.isValid() ? parsedDate : undefined}
                        onSelect={applyDate}
                        onChange={applyDate}
                        allowClear
                        popupClassName="wtb-edit-datepicker-popup"
                        className={inlineInputClass}
                        style={{ width: "100%", height: 32 }}
                        onClick={(e) => e.stopPropagation()}
                      />
                    );
                  }
                  return value;
                },
              },
              {
                title: "Manufacturer",
                dataIndex: "manu",
                key: "manu",
                align: "left",
                width: "13%",
                onHeaderCell: () => ({ style: { backgroundColor: "#DFEFFF", color: "black", fontWeight: "600", fontSize: "14px" } }),
                onCell: () => ({ style: { overflow: "hidden", maxWidth: 0, whiteSpace: "nowrap" } }),
                render: (value, record) => {
                  if (record.isNew) {
                    return (
                      <Select
                        size="small"
                        showSearch
                        bordered={false}
                        value={record.manu || undefined}
                        placeholder="Select manufacturer"
                        className={inlineSelectClass}
                        options={manufacturerOptions}
                        popupMatchSelectWidth={false}
                        dropdownStyle={{ minWidth: 260 }}
                        filterOption={(input, option) =>
                          String(option?.label ?? "").toLowerCase().startsWith(input.toLowerCase())
                        }
                        onChange={(val) => handleRowChange(record.id, "manu", val)}
                      />
                    );
                  }
                  if (record.id === editingRowId && editingRowData) {
                    return (
                      <Select
                        size="small"
                        showSearch
                        bordered={false}
                        value={editingRowData.manu || undefined}
                        placeholder="Select manufacturer"
                        className={inlineSelectClass}
                        options={manufacturerOptions}
                        popupMatchSelectWidth={false}
                        dropdownStyle={{ minWidth: 260 }}
                        filterOption={(input, option) =>
                          String(option?.label ?? "").toLowerCase().startsWith(input.toLowerCase())
                        }
                        onChange={(val) => handleEditChange("manu", val)}
                        onClick={(e) => e.stopPropagation()}
                      />
                    );
                  }
                  return value;
                },
              },
              {
                title: "Model",
                dataIndex: "model",
                key: "model",
                align: "left",
                width: "9%",
                onHeaderCell: () => ({
                  style: {
                    backgroundColor: "#DFEFFF",
                    color: "black",
                    fontWeight: "600",
                    fontSize: "14px",
                  },
                }),
                render: (value, record) => {
                  if (record.isNew) {
                    return (
                      <Input
                        size="small"
                        value={record.model}
                        className={inlineInputClass}
                        onChange={(e) => handleRowChange(record.id, "model", e.target.value)}
                      />
                    );
                  }
                  if (record.id === editingRowId && editingRowData) {
                    return (
                      <Input
                        size="small"
                        value={editingRowData.model}
                        className={inlineInputClass}
                        onChange={(e) => handleEditChange("model", e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                      />
                    );
                  }
                  return value;
                },
              },
              {
                title: "Options",
                dataIndex: "options",
                key: "options",
                align: "left",
                width: "16%",
                onHeaderCell: () => ({
                  style: {
                    backgroundColor: "#DFEFFF",
                    color: "black",
                    fontWeight: "600",
                    fontSize: "14px",
                  },
                }),
                render: (value, record) => {
                  if (record.isNew) {
                    return (
                      <Input
                        size="small"
                        value={record.options}
                        className={inlineInputClass}
                        onChange={(e) => handleRowChange(record.id, "options", e.target.value)}
                      />
                    );
                  }
                  if (record.id === editingRowId && editingRowData) {
                    return (
                      <Input
                        size="small"
                        value={editingRowData.options}
                        className={inlineInputClass}
                        onChange={(e) => handleEditChange("options", e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                      />
                    );
                  }
                  return value;
                },
              },
              {
                title: "Keep Alive",
                key: "keepAlive",
                align: "center",
                width: "7%",
                onHeaderCell: () => ({
                  style: {
                    backgroundColor: "#DFEFFF",
                    color: "black",
                    fontWeight: "600",
                    fontSize: "14px",
                  },
                }),
                render: (_, record) => (
                  <div className="flex justify-center">
                    <input
                      type="checkbox"
                      checked={record.keepAlive}
                      onChange={async (e) => {
                        const checked = e.target.checked;
                        setData((prev) =>
                          prev.map((row) =>
                            row.id === record.id ? { ...row, keepAlive: checked } : row,
                          ),
                        );
                        // Keep editingRowData in sync so Save sends the correct value
                        if (record.id === editingRowId) {
                          setEditingRowData((prev) => prev ? { ...prev, keepAlive: checked } : prev);
                          return;
                        }
                        if (record.isNew) return;
                        try {
                          await updateQuoteWtb(record.id, { keepAlive: checked });
                        } catch (error: any) {
                          setData((prev) =>
                            prev.map((row) =>
                              row.id === record.id
                                ? { ...row, keepAlive: !checked }
                                : row,
                            ),
                          );
                          message.error(
                            error?.response?.data?.message ||
                              "Failed to update keepAlive",
                          );
                        }
                      }}
                      className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"
                      style={{ borderRadius: 0 }}
                    />
                  </div>
                ),
              },
              {
                title: "Status",
                dataIndex: "status",
                key: "status",
                align: "left",
                width: "8%",
                onHeaderCell: () => ({
                  style: {
                    backgroundColor: "#DFEFFF",
                    color: "black",
                    fontWeight: "600",
                    fontSize: "14px",
                  },
                }),
                render: (value, record) => {
                  if (record.isNew) {
                    return (
                      <Select
                        size="small"
                        bordered={false}
                        value={record.status || "Active"}
                        className={inlineSelectClass}
                        popupClassName="status-select-dropdown"
                        popupMatchSelectWidth={false}
                        dropdownStyle={{ minWidth: 120 }}
                        onChange={(v) => handleRowChange(record.id, "status", v)}
                        options={[
                          { value: "Active", label: "Active" },
                          { value: "Sent", label: "Sent" },
                          { value: "Closed", label: "Closed" },
                        ]}
                      />
                    );
                  }
                  if (record.id === editingRowId && editingRowData) {
                    return (
                      <Select
                        size="small"
                        bordered={false}
                        value={editingRowData.status || "Active"}
                        className={inlineSelectClass}
                        popupMatchSelectWidth={false}
                        dropdownStyle={{ minWidth: 120 }}
                        onChange={(v) => handleEditChange("status", v)}
                        onClick={(e) => e.stopPropagation()}
                        options={[
                          { value: "Active", label: "Active" },
                          { value: "Sent", label: "Sent" },
                          { value: "Closed", label: "Closed" },
                        ]}
                      />
                    );
                  }
                  return value;
                },
              },
              {
                title: "Priority",
                dataIndex: "priority",
                key: "priority",
                align: "center",
                width: "4%",
                onHeaderCell: () => ({
                  style: {
                    backgroundColor: "#DFEFFF",
                    color: "black",
                    fontWeight: "600",
                    fontSize: "14px",
                  },
                }),
                render: (value, record) => {
                  if (record.isNew) {
                    return (
                      <Input
                        size="small"
                        value={String(record.priority || 0)}
                        className={inlineInputClass}
                        onChange={(e) => handleRowChange(record.id, "priority", Number(e.target.value || 0))}
                      />
                    );
                  }
                  if (record.id === editingRowId && editingRowData) {
                    return (
                      <Input
                        size="small"
                        value={String(editingRowData.priority || 0)}
                        className={inlineInputClass}
                        onChange={(e) => handleEditChange("priority", Number(e.target.value || 0))}
                        onClick={(e) => e.stopPropagation()}
                      />
                    );
                  }
                  return value;
                },
              },
              {
                title: "Type",
                dataIndex: "type",
                key: "type",
                align: "center",
                width: "7%",
                onHeaderCell: () => ({
                  style: {
                    backgroundColor: "#DFEFFF",
                    color: "black",
                    fontWeight: "600",
                    fontSize: "14px",
                  },
                }),
                render: (value, record) => {
                  if (record.isNew) {
                    return (
                      <Select
                        size="small"
                        bordered={false}
                        value={record.type}
                        className={inlineSelectClass}
                        onChange={(v) => handleRowChange(record.id, "type", v)}
                        options={[
                          { value: "WTB", label: "WTB" },
                          { value: "CAL", label: "CAL" },
                          { value: "WTS", label: "WTS" },
                        ]}
                      />
                    );
                  }
                  if (record.id === editingRowId && editingRowData) {
                    return (
                      <Select
                        size="small"
                        bordered={false}
                        value={editingRowData.type}
                        className={inlineSelectClass}
                        onChange={(v) => handleEditChange("type", v)}
                        onClick={(e) => e.stopPropagation()}
                        options={[
                          { value: "WTB", label: "WTB" },
                          { value: "CAL", label: "CAL" },
                          { value: "WTS", label: "WTS" },
                        ]}
                      />
                    );
                  }
                  return value;
                },
              },
              {
                title: "Action",
                key: "action",
                align: "center",
                width: "10%",
                onHeaderCell: () => ({
                  style: {
                    backgroundColor: "#DFEFFF",
                    color: "black",
                    fontWeight: "600",
                    paddingRight: "20px",
                    fontSize: "14px",
                  },
                }),
                onCell: () => ({
                  style: { paddingRight: "20px", fontWeight: "400" },
                }),
                render: (_, record) => (
                  <div className="flex justify-center">
                    {record.isNew ? (
                      <div className="flex gap-2">
                        <button
                          className="px-3 py-1 text-xs bg-blue-100 text-blue-700 border border-blue-300 hover:bg-blue-200 rounded"
                          onClick={(e) => { e.stopPropagation(); handleSaveNewRow(record); }}
                        >
                          Save
                        </button>
                        <button
                          className="px-3 py-1 text-xs bg-gray-100 text-gray-700 border border-gray-300 hover:bg-gray-200 rounded"
                          onClick={(e) => { e.stopPropagation(); deleteRow(record.id); }}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : record.id === editingRowId ? (
                      <div className="flex gap-1">
                        <button
                          className="px-1.5 py-0.5 text-[11px] bg-blue-100 text-blue-700 border border-blue-300 hover:bg-blue-200 rounded"
                          onClick={(e) => { e.stopPropagation(); handleSaveEdit(); }}
                        >
                          Save
                        </button>
                        <button
                          className="px-1.5 py-0.5 text-[11px] bg-gray-100 text-gray-700 border border-gray-300 hover:bg-gray-200 rounded"
                          onClick={(e) => { e.stopPropagation(); handleCancelEdit(); }}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <button
                        className="px-3 py-1 text-xs bg-red-100 text-red-700 border border-red-300 hover:bg-red-200 rounded"
                        onClick={(e) => { e.stopPropagation(); deleteRow(record.id); }}
                      >
                        Delete
                      </button>
                    )}
                  </div>
                ),
              },
              {
                title: "",
                dataIndex: "source",
                key: "source",
                align: "left",
                width: "12%",
                onHeaderCell: () => ({ style: { backgroundColor: "#DFEFFF" } }),
                onCell: () => ({ style: { overflow: "hidden", maxWidth: 0 } }),
                render: (value, record) => {
                  if (record.isNew) {
                    return (
                      <Input
                        size="small"
                        value={record.source}
                        className={inlineInputClass}
                        onChange={(e) => handleRowChange(record.id, "source", e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                      />
                    );
                  }
                  if (record.id === editingRowId && editingRowData) {
                    return (
                      <Input
                        size="small"
                        value={editingRowData.source}
                        className={inlineInputClass}
                        onChange={(e) => handleEditChange("source", e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                      />
                    );
                  }
                  return value;
                },
              },
            ]}
            pagination={false}
            loading={isLoading}
            className="custom-table"
            rowKey="id"
            onRow={(record) => ({
              onClick: (e) => {
                const target = e.target as HTMLElement;
                // Don't enter edit mode when clicking interactive elements
                if (
                  target.closest(".ant-select") ||
                  target.closest(".ant-picker") ||
                  target.closest("button") ||
                  target.closest("input")
                ) return;
                if (record.isNew) return;
                if (editingRowId !== record.id) {
                  // Cancel any previous edit without saving
                  if (editingRowId) handleCancelEdit();
                  handleStartEdit(record);
                }
              },
              style: {
                cursor: record.isNew || record.id === editingRowId ? "default" : "pointer",
                background: record.id === editingRowId ? "#fffbe6" : undefined,
              },
            })}
          />
          {!isFindMode && (
          <div className="flex items-center justify-between mt-3 px-1">
            <span className="text-sm text-gray-500">
              {totalRecords > 0
                ? `${((currentPage - 1) * pageSize) + 1}–${Math.min(currentPage * pageSize, totalRecords)} of ${totalRecords.toLocaleString()} records`
                : ""}
            </span>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={totalRecords}
              showSizeChanger
              pageSizeOptions={["50", "100", "200", "500"]}
              onChange={(page, size) => {
                setCurrentPage(page);
                setPageSize(size);
              }}
            />
          </div>
          )}
        </div>
      </div>
      <Modal
        title={
          <span>
            <img src={mailSendIcon} style={{ width: 18, height: 18, objectFit: "contain", marginRight: 8 }} />
            Send WTB Listing Email
            <span className="ml-2 text-sm font-normal text-gray-500">
              ({rows.length} record{rows.length !== 1 ? "s" : ""}{isFiltered ? ` – filtered` : ""})
            </span>
          </span>
        }
        open={showEmailModal}
        onCancel={() => setShowEmailModal(false)}
        footer={null}
        width={700}
      >
        <div className="space-y-4 pt-2">
          <div className="flex items-center gap-3">
            <span className="min-w-[60px] text-sm font-medium text-gray-600">To:</span>
            <Input
              placeholder="recipient@example.com"
              value={emailTo}
              onChange={(e) => setEmailTo(e.target.value)}
              onPressEnter={handleSendEmail}
              size="small"
            />
          </div>
          <div className="flex items-center gap-3">
            <span className="min-w-[60px] text-sm font-medium text-gray-600">Subject:</span>
            <Input
              value={emailSubject}
              onChange={(e) => setEmailSubject(e.target.value)}
              size="small"
            />
          </div>

          {/* Preview table */}
          <div>
            <p className="text-xs text-gray-500 mb-2">Records to be sent:</p>
            <div className="border rounded overflow-auto max-h-64">
              <table className="w-full text-xs border-collapse">
                <thead>
                  <tr className="bg-[#DFEFFF]">
                    <th className="p-2 text-left border-b border-gray-200">Requested</th>
                    <th className="p-2 text-left border-b border-gray-200">Manufacturer</th>
                    <th className="p-2 text-left border-b border-gray-200">Model</th>
                    <th className="p-2 text-left border-b border-gray-200">Options</th>
                    <th className="p-2 text-center border-b border-gray-200">Keep Alive</th>
                    <th className="p-2 text-left border-b border-gray-200">Status</th>
                    <th className="p-2 text-center border-b border-gray-200">Priority</th>
                    <th className="p-2 text-center border-b border-gray-200">Type</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r, i) => (
                    <tr key={r.id} className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                      <td className="p-2 border-b border-gray-100">{r.requested}</td>
                      <td className="p-2 border-b border-gray-100">{r.manu}</td>
                      <td className="p-2 border-b border-gray-100">{r.model}</td>
                      <td className="p-2 border-b border-gray-100">{r.options}</td>
                      <td className="p-2 border-b border-gray-100 text-center">{r.keepAlive ? "Yes" : "No"}</td>
                      <td className="p-2 border-b border-gray-100">{r.status}</td>
                      <td className="p-2 border-b border-gray-100 text-center">{r.priority}</td>
                      <td className="p-2 border-b border-gray-100 text-center">{r.type}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <Button size="small" onClick={() => setShowEmailModal(false)}>
              Cancel
            </Button>
            <Button
              type="primary"
              size="small"
              loading={emailSending}
              className="bg-[#004AAD]"
              onClick={handleSendEmail}
            >
              Send Email
            </Button>
          </div>
        </div>
      </Modal>

      {/* <div className="bg-white rounded-2xl shadow-sm p-4">
        <h3 className="text-lg font-medium text-gray-800 mb-4">Listing</h3>

        <div className="border border-gray-200 bg-white overflow-auto rounded">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-[#F2F2F2]">
                <th
                  className="text-left p-2 border-b border-[#A29F9F] font-medium text-sm"
                  style={{ width: "170px" }}
                >
                  Requested
                </th>
                <th
                  className="text-left p-2 border-b border-[#A29F9F] font-medium text-sm"
                  style={{ width: "170px" }}
                >
                  Manu
                </th>
                <th
                  className="text-left p-2 border-b border-[#A29F9F] font-medium text-sm"
                  style={{ width: "90px" }}
                >
                  Model
                </th>
                <th className="text-left p-2 border-b border-[#A29F9F] font-medium text-sm">
                  Options
                </th>
                <th
                  className="text-center p-2 border-b border-[#A29F9F] font-medium text-sm"
                  style={{ width: "90px" }}
                >
                  KeepAlive
                </th>
                <th
                  className="text-left p-2 border-b border-[#A29F9F] font-medium text-sm"
                  style={{ width: "90px" }}
                >
                  Status
                </th>
                <th
                  className="text-center p-2 border-b border-[#A29F9F] font-medium text-sm"
                  style={{ width: "70px" }}
                >
                  Priority
                </th>
                <th
                  className="text-center p-2 border-b border-[#A29F9F] font-medium text-sm"
                  style={{ width: "70px" }}
                >
                  Type
                </th>
                <th
                  className="text-left p-2 border-b border-[#A29F9F] font-medium text-sm"
                  style={{ width: "80px" }}
                ></th>
                <th
                  className="text-left p-2 border-b border-[#A29F9F] font-medium text-sm"
                  style={{ width: "120px" }}
                >
                  Owner
                </th>
              </tr>
            </thead>

            <tbody>
              {rows.map((r, idx) => (
                <tr
                  key={r.id}
                  className={`${idx % 2 ? "bg-gray-50" : "bg-white"} hover:bg-blue-50`}
                >
                  <td className="p-2 border-b border-gray-200">
                    <div className="text-[12px] text-gray-800 px-2 py-1">
                      {r.requested}
                    </div>
                  </td>
                  <td className="p-2 border-b border-gray-200">
                    <div className="text-[12px] text-gray-800 px-2 py-1">
                      {r.manu}
                    </div>
                  </td>
                  <td className="p-2 border-b border-gray-200">
                    <div className="text-[12px] text-gray-800 px-2 py-1">
                      {r.model}
                    </div>
                  </td>
                  <td className="p-2 border-b border-gray-200">
                    <div
                      className={`text-[12px] px-2 py-1 `}
                      style={{ borderRadius: 4 }}
                    >
                      {r.options}
                    </div>
                  </td>
                  <td className="p-2 border-b border-gray-200 text-center">
                    <div className="flex items-center justify-center">
                      <input
                        type="checkbox"
                        checked={r.keepAlive}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setData((prev) =>
                            prev.map((row) =>
                              row.id === r.id
                                ? { ...row, keepAlive: checked }
                                : row,
                            ),
                          );
                        }}
                        className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"
                        style={{ borderRadius: 0 }}
                      />
                    </div>
                  </td>
                  <td className="p-2 border-b border-gray-200">
                    <div className="text-[12px] text-gray-800 px-2 py-1">
                      {r.status}
                    </div>
                  </td>
                  <td className="p-2 border-b border-gray-200 text-center">
                    <div
                      className={`text-[12px] px-2 py-1 `}
                      style={{ borderRadius: 4 }}
                    >
                      {r.priority}
                    </div>
                  </td>
                  <td className="p-2 border-b border-gray-200 text-center">
                    <div className="text-[12px] text-gray-800 px-2 py-1">
                      {r.type}
                    </div>
                  </td>
                  <td className="p-2 border-b border-gray-200">
                    <button
                      className="px-3 py-1 text-xs bg-red-100 text-red-700 border border-red-300 hover:bg-red-200"
                      onClick={() => deleteRow(r.id)}
                      style={{ borderRadius: 4 }}
                    >
                      Delete
                    </button>
                  </td>
                  <td className="p-2 border-b border-gray-200">
                    <div
                      className="text-[12px] text-black px-2 py-1 "
                      style={{ borderRadius: 4 }}
                    >
                      {r.owner}
                    </div>
                  </td>
                </tr>
              ))}

              
              {Array.from({ length: Math.max(0, 5 - rows.length) }).map(
                (_, i) => (
                  <tr
                    key={`empty-${i}`}
                    className={`${(rows.length + i) % 2 ? "bg-gray-50" : "bg-white"}`}
                  >
                    <td className="p-2 border-b border-gray-200">
                      <div className="text-[12px] text-gray-400 px-2 py-1">
                        &nbsp;
                      </div>
                    </td>
                    <td className="p-2 border-b border-gray-200">
                      <div className="text-[12px] text-gray-400 px-2 py-1">
                        &nbsp;
                      </div>
                    </td>
                    <td className="p-2 border-b border-gray-200">
                      <div className="text-[12px] text-gray-400 px-2 py-1">
                        &nbsp;
                      </div>
                    </td>
                    <td className="p-2 border-b border-gray-200">
                      <div className="text-[12px] text-gray-400 px-2 py-1">
                        &nbsp;
                      </div>
                    </td>
                    <td className="p-2 border-b border-gray-200 text-center">
                      <input
                        type="checkbox"
                        className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"
                        style={{ borderRadius: 0 }}
                      />
                    </td>
                    <td className="p-2 border-b border-gray-200">
                      <div className="text-[12px] text-gray-400 px-2 py-1">
                        &nbsp;
                      </div>
                    </td>
                    <td className="p-2 border-b border-gray-200">
                      <div className="text-[12px] text-gray-400 px-2 py-1">
                        &nbsp;
                      </div>
                    </td>
                    <td className="p-2 border-b border-gray-200">
                      <div className="text-[12px] text-gray-400 px-2 py-1">
                        &nbsp;
                      </div>
                    </td>
                    <td className="p-2 border-b border-gray-200"></td>
                    <td className="p-2 border-b border-gray-200">
                      <div className="text-[12px] text-gray-400 px-2 py-1">
                        &nbsp;
                      </div>
                    </td>
                  </tr>
                ),
              )}
            </tbody>
          </table>
        </div>
      </div> */}
    </div>
  );
};

export default QuotesWtb;
